const actions = {
  REQUESTING: 'QualityControls/REQUESTING',
  RESPONSE_ERROR: 'QualityControls/RESPONSE_ERROR',

  FETCH_QUALITYCONTROLS: 'QualityControls/FETCH',
  LIST_QUALITYCONTROL: 'QualityControl/LIST',

  FETCH_QUALITYCONTROL: 'QualityControl/FETCH',
  NEW_QUALITYCONTROL: 'QualityControl/NEW',
  EDIT_QUALITYCONTROL: 'QualityControl/EDIT',
  RESET_QUALITYCONTROL: 'QualityControl/RESET',

  RE_FETCH_QUALITYCONTROLS: 'QualityControls/REFRESH',
  SAVE_QUALITYCONTROL: 'QualityControl/SAVE',
  SAVE_QUALITYCONTROL_RECIEVED: 'QualityControl/SAVE_QUALITYCONTROL_RECIEVED',

  DELETE_QUALITYCONTROL: 'QualityControl/DELETE',
  DELETE_QUALITYCONTROL_RECIEVED: 'QualityControl/DELETE_RECIEVED',
}

export default actions
